<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { computed } from 'vue';
import { useRoute, useRouter } from '#app/composables/router';
import { useContentEmptyStateGuard } from '#layers/spaces/composables/use-content-empty-state-guard';

const { to, description, showIcon = true } = defineProps<{
	/** Where Create Collection leads. Defaults to Data Model sources; `null` hides the button. */
	to?: RouteLocationRaw | null;
	/** Replaces the description shown to users who may create collections. */
	description?: string;
	showIcon?: boolean;
}>();

const route = useRoute();
const router = useRouter();
const emptyState = useContentEmptyStateGuard(() => description);
const actionButtonLabel = computed(() => to === null ? undefined : emptyState.value.actionButtonLabel);

function goToCollectionCreation() {
	router.push(to ?? { name: 'data-model.sources', params: { workspace: route.params.workspace } });
}
</script>

<template>
	<DEmpty
		v-bind="emptyState"
		:icon="showIcon ? 'lucide:box' : undefined"
		:action-button-label
		@action="goToCollectionCreation"
	/>
</template>
